import React, { useEffect, useState } from "react";
import { useToast } from "../hooks/use-toast";

// TODO: sustituye por la URL real de tu script (raw de GitHub, tu Worker, etc.)
const LOADSTRING_URL = "https://raw.githubusercontent.com/MinirickDev/MinirickHub/refs/heads/main/MinirickHub";
const LOADSTRING_CODE = `loadstring(game:HttpGet("${LOADSTRING_URL}"))()`;

const ASCII_BANNER = ` --[[

███╗   ███╗██╗███╗   ██╗██╗██████╗ ██╗ ██████╗██╗  ██╗██╗  ██╗██╗   ██╗██████╗
████╗ ████║██║████╗  ██║██║██╔══██╗██║██╔════╝██║ ██╔╝██║  ██║██║   ██║██╔══██╗
██╔████╔██║██║██╔██╗ ██║██║██████╔╝██║██║     █████╔╝ ███████║██║   ██║██████╔╝
██║╚██╔╝██║██║██║╚██╗██║██║██╔══██╗██║██║     ██╔═██╗ ██╔══██║██║   ██║██╔══██╗
██║ ╚═╝ ██║██║██║ ╚████║██║██║  ██║██║╚██████╗██║  ██╗██║  ██║╚██████╔╝██████╔╝
╚═╝     ╚═╝╚═╝╚═╝  ╚═══╝╚═╝╚═╝  ╚═╝╚═╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝ ╚═════╝ ╚═════╝

]]`;

const LoadstringReveal = () => {
  const { toast } = useToast();
  const [progress, setProgress] = useState(0);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setProgress(92), 120);
    const t2 = setTimeout(() => setProgress(100), 900);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(LOADSTRING_CODE);
    } catch (e) {
      // clipboard bloqueado; ignorar
    }
    setCopied(true);
    toast({ title: "Copiado", description: "Loadstring copiado al portapapeles." });
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="stark-root">
      <div className="stark-glow stark-glow--tl" />
      <div className="stark-glow stark-glow--br" />
      <div className="stark-grain" />

      <main className="stark-center">
        <section className="stark-card is-in loadstring-card" aria-label="Loadstring">
          <h1 className="stark-title">MinirickHub</h1>

          <div className="code-block">
            <pre>
              <span className="code-comment">{"--[["}</span>
              {"\n"}
              <span className="code-comment">{ASCII_BANNER}</span>
              {"\n"}
              <span className="code-comment">{"]]"}</span>
              {"\n\n"}
              <span className="code-fn">loadstring</span>
              <span className="code-punct">(</span>
              <span className="code-var">game</span>
              <span className="code-punct">:</span>
              <span className="code-fn">HttpGet</span>
              <span className="code-punct">(</span>
              <span className="code-string">"{LOADSTRING_URL}"</span>
              <span className="code-punct">)</span>
              <span className="code-punct">)</span>
              <span className="code-punct">()</span>
            </pre>
          </div>

          <div className="loadstring-progress">
            <div className="loadstring-progress__bar" style={{ width: `${progress}%` }} />
          </div>

          <button
            type="button"
            className="stark-btn stark-btn--primary loadstring-copy"
            onClick={handleCopy}
          >
            <span className="stark-btn__label">
              {copied ? "Copiado ✓" : "Copy Loadstring"}
            </span>
          </button>
        </section>
      </main>
    </div>
  );
};

export default LoadstringReveal;
